import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatOrderSubtotal } from "./fulfillment-group-csv-utils";

export const OrderSubtotalCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Order subtotal", cell: (row) => formatOrderSubtotal(row) };
